<app-auth-navbar></app-auth-navbar>
<router-outlet></router-outlet>
<app-auth-footer></app-auth-footer>
